import { Box, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import EmployerLetsStart from '../Employer/EmployerLetsStart'
import RecentlyJoined from '../Employer/RecentlyJoined'
import EmployerOverview from '../Employer/EmployerOverview'
import EmployerTestimonial from '../Employer/EmployerTestimonial'
import CoachSideBar from './Profile/CoachSideBar'
import { getAllService, getUserInformation, getUsersByProfile } from '../../actions/userAuth'
import { useDispatch, useSelector } from 'react-redux'
import Navbar from '../Navbar'
import { useNavigate } from 'react-router-dom'
import CoachTopServices from './CoachTopServices'
import TopCoaches from './TopCoaches'
import Layout from '../../assets/Layout'
import UserLayout from '../../assets/UserLayout'
import CoachChart from './CoachChart'


export default function CoachDashboard() {
  const { user } = useSelector((state) => ({ ...state }));
  const [services, setServices] = useState([]);
  const [coachs, setCoachs] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!localStorage.getItem("user")) {
      navigate('/')
    }
  }, [])

  useEffect(() => {
    dispatch(getUsersByProfile({role: 'COACH'},(data) => {
      setCoachs(data.data.data);
    }))
  },[])

  useEffect(() => {
    dispatch(getAllService({},(data) => {
      setServices(data.data.data);
    }))
  },[])

  return (
    <>
      <Layout>
        <UserLayout userRole={"coach"}>
          <Box px={{md:4, xs:1}}>
            <CoachChart />
          </Box>
          <Box px={{md:4, xs:1}}>
            <EmployerLetsStart />
          </Box>
          <Box px={{md:4, xs:1}}>
            <CoachTopServices services={services}/>
          </Box>

          <Box px={{md:4, xs:1}}>
            <TopCoaches coachs={coachs}/>
          </Box>
          <Box px={{md:4, xs:1}}>
            <EmployerOverview />
          </Box>
        </UserLayout>
      </Layout>
    </>
  )
}
